import React, { useEffect, useMemo, useState } from "react";
import { Box, TextField, Button, Typography, Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import { getUrl } from "src/Utils/Common";
import axios from "axios";
import MarketeersBackground from "./MarketeersBackground";
import backgroundProject from "src/Assets/MarketeersLogo.png";

const EmailLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginKind, setLoginKind] = useState("premium"); 
  const navigate = useNavigate();

  const requestDemoHref = useMemo(() => "https://marketeersresearch.com/", []);

  useEffect(() => {
    const saved = localStorage.getItem("loginKind");
    if (saved === "free_trial" || saved === "premium") setLoginKind(saved);
  }, []);

  useEffect(() => {
    if (loginKind) localStorage.setItem("loginKind", loginKind);
    else localStorage.removeItem("loginKind");
  }, [loginKind]);

  const handleEmailLogin = () => {
    setError("");
    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }
    if (!email.includes("@")) {
      setError("Please enter a valid email address");
      return;
    }
    setLoading(true);
    
    if (email && password) {
        axios.post(
          `${getUrl()}/auth/login`,
          // Body as a plain URLSearchParams object
          new URLSearchParams({
            email: email,
            password: password,
          }).toString(),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded", // Match backend expectations
              "x-cors-api-key": "temp_8c8f91f122df0ef9daa49a6701f13f76",
            },
          }
        )
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            console.log("Login successful:", response.data);
            const data = response.data;
            console.log("Login successful:", data);

            // Store the token in localStorage
            localStorage.setItem("userId", data.token);
            localStorage.setItem(
              "requiresPasswordChange",
              data.requires_password_change ? "true" : "false"
            );
            localStorage.setItem("page", "Dashboard & KPIs");
            localStorage.setItem("name", data.name);
            if (data.manufacturer) localStorage.setItem("manufacturer", data.manufacturer);
            else localStorage.removeItem("manufacturer");
            localStorage.setItem("role", data.role);
            localStorage.removeItem("loginKind");

            // Navigate to the next page
            if (data.requires_password_change) {
              navigate("/change-password");
              return;
            }
            if (data.role === "free_trial") {
              navigate("/upload-excel");
            } else {
              navigate("/select-user-id");
            }
          } 
        })
      .catch ((err) => {
        console.error("Error logging in:", err);
        if (err?.response) {
          const backendMsg =
            err.response.data?.message ||
            err.response.data?.error ||
            err.response.data?.detail ||
            (typeof err.response.data === "string" ? err.response.data : null);

          setError(
            backendMsg
              ? `Login failed: ${backendMsg}`
              : `Login failed (HTTP ${err.response.status}). Please try again.`
          );
        } else {
          setError("Login failed: network error. Please try again.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
    };
  }

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={6}>
        <MarketeersBackground src={backgroundProject} />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#F4F6FB",
          p: { xs: 2, sm: 4 },
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "100%",
            maxWidth: 480,
            borderRadius: 4,
            p: { xs: 3, sm: 4 },
            boxShadow: "0 14px 35px rgba(0,0,0,0.08)",
          }}
        >
          <Box mb={2} textAlign="left">
            <Typography
              variant="overline"
              sx={{ color: "#929292", letterSpacing: 1 }}
            >
              Welcome
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "primary.main",
              }}
            >
              {loginKind === "free_trial"
                ? "Free Trial Login"
                : loginKind === "premium"
                  ? "Login"
                  : "Choose your access"}
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5, color: "#555" }}>
              {loginKind
                ? "Enter your email and password to continue."
                : "Select your plan first, then sign in."}
            </Typography>
          </Box>

          <Typography
            variant="h5"
            sx={{
              marginBottom: 4,
              fontFamily: "'Courier New', Courier, monospace",
              fontWeight: "bold",
              color: "primary.main",
              textAlign: "left",
              minHeight: 55,
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
            }}
          >
            <Box component="span" sx={{ display: "inline-block" }}>
              <Typewriter
                words={[
                  "Welcome to Marketeers Research.",
                  "Your gateway to data-driven insights.",
                  "Empowering solutions for your business.",
                ]}
                loop={true}
                cursor
                cursorStyle="|"
                typeSpeed={50}
                deleteSpeed={30}
                delaySpeed={2000}
              />
            </Box>
          </Typography>

          {/*
            {!loginKind ? (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 1.5,
                  }}
                >
                  <Chip label="Step 1 of 2" size="small" />
                </Box>

                <Typography variant="body2" sx={{ color: "#555", mb: 2 }}>
                  Choose the access type that matches your account.
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => setLoginKind("free_trial")}
                      sx={{
                        borderRadius: 3,
                        fontWeight: "bold",
                        py: 1.4,
                        textTransform: "none",
                        justifyContent: "flex-start",
                        px: 2,
                      }}
                    >
                      <Box sx={{ textAlign: "left" }}>
                        <Typography sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                          Free Trial
                        </Typography>
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                          Explore with demo access
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => setLoginKind("premium")}
                      sx={{
                        borderRadius: 3,
                        fontWeight: "bold",
                        py: 1.4,
                        textTransform: "none",
                        justifyContent: "flex-start",
                        px: 2,
                      }}
                    >
                      <Box sx={{ textAlign: "left" }}>
                        <Typography sx={{ fontWeight: 800, lineHeight: 1.2 }}>
                          Premium
                        </Typography>
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                          Full access for subscribers
                        </Typography>
                      </Box>
                    </Button>
                  </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                <Button
                  component="a"
                  href={requestDemoHref}
                  target="_blank"
                  rel="noreferrer"
                  variant="text"
                  color="primary"
                  sx={{ fontWeight: 700, textTransform: "none", p: 0, minWidth: 0 }}
                >
                  {"Don't have an account? Request a demo"}
                </Button>
              </Box>
            ) : (
          */}
          <>
          {error && (
            <Typography 
              color="error" 
              sx={{ 
                marginBottom: 2,
                textAlign: "center",
                width: "60%",
                fontWeight: "700",
              }}
            >
              {error}
            </Typography>
          )}
          
          <TextField
            fullWidth
            label="Email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!error && (!email || !email.includes("@"))}
            sx={{ 
              marginBottom: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                "& fieldset": {
                  borderRadius: 3,
                },
              },
            }}
            disabled={loading}
          />
          <TextField
            fullWidth
            label="Password"
            type="password"
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!error && !password}
            sx={{ 
              marginBottom: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                "& fieldset": {
                  borderRadius: 3,
                },
              },
            }}
            disabled={loading}
          />

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleEmailLogin}
            disabled={loading}
            sx={{
              borderRadius: 3,
              fontWeight: "bold",
              textTransform: "uppercase",
              py: 1,
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>

          {loginKind === "free_trial" && (
            <Button
              component="a"
              href={requestDemoHref}
              target="_blank"
              rel="noreferrer"
              variant="outlined"
              color="primary"
              fullWidth
              sx={{
                borderRadius: 3,
                fontWeight: "bold",
                textTransform: "uppercase",
                py: 1,
                mt: 1.5,
              }}
            >
              Request a demo
            </Button>
          )}
            </>
          {/*
            )}
          */}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default EmailLogin;
